import { colors } from "components/themes/colors"
import styled from "styled-components"

export const PricingPageWrapper = styled.div``
